/** UI label for `User.jobTitle` — not „Funktion“ (that is used for intranet contact rows). */
export const USER_JOB_TITLE_LABEL = 'Stellenbezeichnung' as const;
